/*!
 * UTF-8 Validation Code originally from:
 * ws: a node.js websocket client
 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
 * MIT Licensed
 */

try {
    module.exports = require('../build/Release/validation');
} catch (e) { try {
    module.exports = require('../build/default/validation');
} catch (e) { try {
    module.exports = require('./Validation.fallback');
} catch (e) {
    console.error('validation.node seems not to have been built. Run npm install.');
    throw e;
}}}



//////////////////
// WEBPACK FOOTER
// ./~/web3/~/websocket/lib/Validation.js
// module id = 1999
// module chunks = 0 1 3